<template>
    <div>
        <fullscreen-drawer
            :visible="visible"
            container="body"
            :closable="false"
            data-testid="contentApprovalOnboardingDrawer"
        >
            <img :src="currentStepContent.image" alt="content approval" width="350px" class="g-mt-6 g-mb-6" />

            <g-typography tag="h1" font-weight="semibold" text-align="center" :value="currentStepContent.heading" />
            <g-typography
                v-if="currentStepContent.subHeading"
                tag="p"
                color="grey-6"
                text-align="center"
                :value="currentStepContent.subHeading"
                class="g-mt-2"
            />

            <div class="onboarding-content g-mb-3">
                <div v-if="Array.isArray(currentStepContent.content)" class="content-list g-mt-6">
                    <g-media-object v-for="(content, i) in currentStepContent.content" :key="i" class="g-mb-6">
                        <template #left>
                            <g-icon :name="content.icon" />
                        </template>

                        <template #default>
                            <g-typography font-weight="semibold" :value="content.title" class="g-mb-3" />
                            <g-typography color="grey-6" :value="content.description" />
                        </template>
                    </g-media-object>
                </div>
                <g-typography
                    v-else-if="currentStepContent.content"
                    tag="h3"
                    color="grey-6"
                    text-align="center"
                    :value="currentStepContent.content"
                    class="g-mt-5 g-mb-6"
                />
            </div>

            <g-button
                shape="round"
                theme="live"
                type="primary"
                size="large"
                class="cta-button"
                @click="currentStep === ONBOARDING_STEP_CONTENT_APPROVAL_MADE_EASY ? handleNext() : handleConfirm()"
            >
                {{ currentStepContent.ctaText }}
            </g-button>

            <g-typography
                v-if="currentStepContent.showHelpDocs"
                tag="p"
                color="grey-6"
                text-align="center"
                class="g-mt-6"
            >
                Need support? Visit our
                <a :href="FAQ_CONTENT_APPROVAL" target="_blank">help docs</a>
            </g-typography>
        </fullscreen-drawer>
    </div>
</template>

<script>
    import { ref, computed } from 'vue-demi';
    import { FAQ_CONTENT_APPROVAL } from '../../../../../constants/faqs';
    import {
        CONTENT_APPROVAL_ONBOARDING_STEPS,
        ONBOARDING_STEP_CONTENT_APPROVAL_MADE_EASY,
        ONBOARDING_STEP_SHOW_SHARE_YOUR_BEST_CONTENT
    } from '../../../../../constants/content-approval';
    import FullscreenDrawer from '../../../../library/FullscreenDrawer.vue';

    export default {
        name: 'ContentApprovalOnboardingDrawer',
        components: { FullscreenDrawer },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },

        setup(props, { emit }) {
            const currentStep = ref(ONBOARDING_STEP_CONTENT_APPROVAL_MADE_EASY);
            const currentStepContent = computed(() => {
                return CONTENT_APPROVAL_ONBOARDING_STEPS[currentStep.value];
            });

            const handleNext = () => {
                currentStep.value = ONBOARDING_STEP_SHOW_SHARE_YOUR_BEST_CONTENT;
            };

            const handleConfirm = () => {
                emit('confirm');
            };

            return {
                ONBOARDING_STEP_CONTENT_APPROVAL_MADE_EASY,
                FAQ_CONTENT_APPROVAL,
                currentStep,
                currentStepContent,
                handleNext,
                handleConfirm
            };
        }
    };
</script>

<style lang="scss" scoped>
    .FullscreenDrawer {
        z-index: 9999 !important;
        text-align: center;

        ::v-deep .FullscreenDrawer__content {
            display: flex;
            flex-direction: column;
            align-items: center;

            .onboarding-content {
                max-width: $g-screen-size-xs;
                text-align: left;
                padding: 0 $g-spacing-5;

                .content-list {
                    max-width: 340px;

                    ::v-deep .media-object-left {
                        margin-right: $g-spacing-5;
                    }
                }
            }

            .cta-button {
                width: 200px;
            }

            @media only screen and (max-width: $g-screen-size-xs) {
                .cta-button {
                    width: 100%;
                }

                .onboarding-content {
                    padding: 0;

                    .content-list {
                        max-width: initial;
                    }
                }
            }
        }
    }
</style>
